import t from "styled-components";
import r from "../../utils/colors.js";
import { device as n } from "../../utils/device.js";
const s = t.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: stretch;
  max-width: 350px;
  width: 100%;

  @media ${n.isMobile} {
    max-width: none;
  }

  > div {
    width: inherit;
    max-width: inherit;
  }
`, l = t.label`
  align-self: stretch;
  font-size: 16px;
  line-height: 24px;
  font-family: VIC;
  font-weight: 600;
  overflow-wrap: break-word;
  margin-bottom: 8px;
  color: ${r.blueGrey};
`, c = t.div`
  margin: 7px 10px 0;
`, u = t.div`
  width: 13px;
  height: 22px;
  margin-right: 10px;
`, h = t.div`
  font-family: VIC;
  background-color: ${(i) => i.$isFocused ? r.blueGrey : "transparent"};
  color: ${(i) => i.$isFocused ? r.white : r.blueGrey};
  font-size: ${(i) => i.$isFocused ? "1.125rem" : "1rem"};
  line-height: 1.25;
  border-bottom: 1px solid ${r.darkGrey25};
  padding: 16px 20px;
  -webkit-tap-highlight-color: ${r.blueGrey};
`;
function b(i) {
  return {
    control: (e, o) => ({
      ...e,
      alignSelf: "stretch",
      height: "48px",
      borderRadius: "2px",
      fontSize: "1rem",
      lineHeight: 1.5,
      letterSpacing: "-0.32px",
      outline: "0px !important",
      color: r.blueGrey,
      backgroundColor: o.isDisabled ? r.darkGrey10 : r.white,
      boxShadow: "none",
      border: `1px solid ${i ? r.red : o.isDisabled ? r.darkGrey75 : o.isFocused ? r.orange : r.blueGrey}`,
      width: "100%",
      "&:hover": {
        borderColor: "none"
      }
    }),
    input: (e) => ({
      ...e,
      fontFamily: "VIC",
      "& input": {
        font: "inherit"
      }
    }),
    valueContainer: (e) => ({
      ...e,
      padding: "0 16px"
    }),
    menu: (e) => ({
      ...e,
      width: "100%",
      borderRadius: "2px",
      backgroundColor: `${r.darkGrey10}`,
      marginBottom: 0,
      marginTop: 0
    }),
    option: (e, o) => ({
      ...e,
      backgroundColor: o.isFocused ? `${r.blueGrey}` : "transparent",
      color: o.isFocused ? `${r.white}` : `${r.blueGrey}`,
      fontSize: o.isFocused ? "1.125rem" : "1rem",
      lineHeight: 1.25,
      borderBottom: `1px solid ${r.darkGrey25}`,
      padding: "16px 20px",
      WebkitTapHighlightColor: `${r.blueGrey}`
    }),
    dropdownIndicator: (e) => ({
      ...e,
      zIndex: 1,
      display: "none"
    }),
    indicatorSeparator: (e) => ({
      ...e,
      display: "none"
    }),
    // https://github.com/JedWatson/react-select/issues/1351#issuecomment-505148882
    singleValue: (e, o) => ({
      ...e,
      display: o.selectProps.menuIsOpen ? "none" : "block",
      color: r.blueGrey
    })
  };
}
const g = t.div`
  > div {
    margin-top: 8px;
    justify-content: flex-start;
  }
`, m = t(l)`
  font-weight: 400;
  margin-top: 8px;
  color: ${r.blueGrey75};
`;
export {
  u as ClearIndicatorWrapper,
  g as ErrorWrapper,
  m as HintLabel,
  l as Label,
  c as LoadingIndicatorWrapper,
  h as Option,
  b as Select,
  s as Wrapper
};
